export const hierarchySort =
    (a: Hierarchy.IHierarchyItem, b: Hierarchy.IHierarchyItem) =>
        a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;